<template>
  <div>
    <el-dialog
      title="Change order"
      width="50vw"
      append-to-body
      :visible.sync="dialogFormVisible"
    >
      <draggable v-model="orderedOptions">
        <el-card v-for="(item, i) in orderedOptions" :key="`${i}`">
          <i class="el-icon-more" style="transform: rotate(90deg)" />
          {{ item.label }}
        </el-card>
      </draggable>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm()">Cancel</el-button>
        <el-button type="primary" @click="submitForm()"> Save </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { clone } from 'lodash'

export default {
  data() {
    return {
      dialogFormVisible: false,
      order: []
    }
  },
  props: ['options'],
  computed: {
    orderedOptions: {
      get() {
        const optionByValue = value =>
          this.options.find(option => option.value === value)
        return this.order.map(optionByValue)
      },
      set(value) {
        this.order = value.map(option => option.value)
      }
    }
  },
  methods: {
    openDialog(value) {
      this.order = clone(value)
      this.dialogFormVisible = true
    },
    cancelForm() {
      this.dialogFormVisible = false
      this.$emit('cancel')
    },
    submitForm() {
      this.dialogFormVisible = false
      this.$emit('changeOrder', this.order)
    }
  },
  components: {
    draggable
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-card {
  cursor: pointer;
}
</style>
